/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

export enum PlanAccessLevel {
	live = 'live',
	locked = 'locked',
	archived = 'archived',
}

export enum PlanAccessBackendStatus {
	offline = 'offline',
	online = 'online',
	nearline = 'nearline',
	pendingOffline = 'pendingOffline',
	pendingOnline = 'pendingOnline',
	pendingNearline = 'pendingNearline',
}

export interface IPlanAccessFields {
	// Notice that the readOnlyMode property is commented out. This is because it is being removed as part of the "new" plan archive feature.
	// See https://mocasystems.atlassian.net/browse/TP-6326 for details.
	// readOnlyMode: boolean;
	accessLevel: PlanAccessLevel;
	accessModifiedBy: string; // accessLevel last modified by user
	accessModifiedAt: string; // accessLevel last modified at timestamp
	excludeFromDashboard?: boolean;
	// read-write to the backend, read-only to the frontend:
	backendStatus?: PlanAccessBackendStatus;
	backendStatusAt?: string; // timestamp at which the current backendStatus was reached
}
